
// Get the video
var video = document.getElementById("myVideo");


